import emojiPickerI18n from '@web-lite/emoji-mart-data/i18n/fa.json'
import { LIMITS } from '@weblite/permission'
import { toLocale } from '$helper/functions/text'
import {
  getMessageToken,
  getTextToken,
  getUserToken,
} from '$comp/_app/components/chat/components/body/components/messageList/components/event/react-hook.helper'
import { boldSome } from '$comp/modals/confirmation-dialog/confirmation-dialog.helper'
import { dateTimeFormatter } from '$helper/functions/time'
import { LanguageType } from '../type'
import { FRONT_HOST, TWA_DOWNLOAD_SRC } from '$setup/local-language/constants'

const APP_NAME = 'جریان'

export const translationPersian: LanguageType = {
  serverError: 'مشکلی در ارتباط با سرور پیش آمده است',
  common: {
    add: 'افزودن',
    uploading: 'در حال بارگذاری',
    you: 'شما',
    from: 'از',
    ok: 'تأیید',
    cancel: 'لغو',
    notifications: 'اعلان‌ها',
    loading: 'در حال دریافت...',
    search: 'جستجو...',
    termsAndConditions: 'شرایط و قوانین',
    register: 'ثبت',
    refuse: 'انصراف',
    retry: 'تلاش مجدد',
    admin: 'مدیر',
    owner: 'مالک',
    online: 'آنلاین',
    group: 'گروه',
    channel: 'کانال',
    settings: 'تنظیمات',
    verified: 'تأیید شده',
    skip: 'رد کردن',
    subscriber: 'مشترک',
    member: 'عضو',
    edit: 'ویرایش',
    confirm: 'تأیید',
    remove: 'حذف',
    save: 'ذخیره',
    revert: 'بازگردانی',

    thousand: 'هزار',
    million: 'میلیون',
    billion: 'میلیارد',

    second: 'ثانیه',
    minute: 'دقیقه',
    hour: 'ساعت',

    B: 'بایت',
    KB: 'کیلوبایت',
    MB: 'مگابایت',
    GB: 'گیگابایت',

    male: 'مرد',
    female: 'زن',

    today: 'امروز',
    yesterday: 'دیروز',
    soon: 'بزودی!',
    and: ' و ',
    resume: 'ادامه',
    understand: 'متوجه شدم',
    live: 'زنده',

    privateChannel: 'کانال خصوصی',

    dateFormats: {
      timeDay: (day, time) => `ساعت ${time} روز ${day}`,
      now: 'همین الان',
      nYearsAgo: (n: number) => `${n} سال قبل`,
      nMonthsAgo: (n: number) => `${n} ماه قبل`,
      nDaysAgo: n => `${n} روز قبل`,
      nHoursAgo: (n: number) => `${n} ساعت قبل`,
      nMinutesAgo: (n: number) => `${n} دقیقه قبل`,
    },
    deactive: 'غیر فعال کردن',
    reload: 'بارگذاری مجدد', // TODO
  },
  symbols: {
    openingDoubleQuotation: '»',
    closingDoubleQuotation: '«',
  },
  joinClassField: {
    title: 'لینک عضویت در کلاس',
    placeholder: 'لینک خود را وارد کنید',
    submitText: 'عضویت',
    invalidLinkError: (remainingSeconds: number) =>
      `لینک نامعتبر است. ${toLocale(
        remainingSeconds,
      )} ثانیه دیگر دوباره امتحان کنید.`,
  },
  connectionStatus: {
    connecting: 'در حال اتصال...',
    updating: 'در حال همگام‌سازی...',
    waitingForNetwork: 'در انتظار شبکه...',
    willReconnect: (delay: number) =>
      `اتصال مجدد در ${toLocale(delay, false)} ثانیه`,
  },
  user: {
    name: 'نام',
    lastName: 'نام خانوادگی',
    phone: 'شماره‌ی همراه',
    username: 'نام کاربری',
    bio: 'معرفی کوتاه',
    id: 'شناسه',
    enterName: 'نام را وارد کنید',
    enterLastName: 'نام خانوادگی را وارد کنید',
    location: 'استان و شهر',
    status: {
      online: 'آنلاین',
      recently: 'آخرین بازدید به تازگی',
      withinAWeek: 'آخرین بازدید در هفته‌ی اخیر',
      withinAMonth: 'آخرین بازدید در یک ماه اخیر',
      aLongTimeAgo: 'آخرین بازدید خیلی وقت پیش',
      lastSeenAt: 'آخرین بازدید در ',
      lastSeenYesterday: 'آخرین بازدید دیروز در ',
    },
  },
  menu: {
    roomProfile: {
      viewProfile: 'مشاهده عکس پروفایل',
      viewStory: 'ورود به ماجرا',
    },
    profileImage: {
      newImage: 'بارگذاری عکس',
      replaceImage: 'بارگذاری عکس جایگزین',
      deleteCurrent: 'حذف عکس فعلی',
    },
    blockedUsers: {
      unblocking: 'رفع مسدودیت',
    },
    exceptionUser: {
      removeFromList: 'حذف از فهرست',
    },
    phone: {
      call: 'تماس',
      callThroughNetwork: 'تماس از طریق شبکه',
      copy: 'رونوشت',
      sendMessage: 'ارسال پیام',
      callThroughApp: 'تماس جریان',
      callThroughPhone: 'تماس از طریق تلفن همراه',
    },
    link: {
      open: 'باز کردن',
    },
    hall: {
      leaveGroup: 'ترک گروه',
      leaveChannel: 'ترک کانال',
      adminLeaveGroup: 'ترک و حذف گروه',
      removeFromGroup: 'حذف از گروه',
      removeFromChannel: 'حذف از کانال',
      editAdminRights: 'ویرایش اختیارات مدیر',
      editRights: 'تغییر اختیارات',
      promote: 'ارتقا به مدیر',
      dismissAdmin: 'برکناری مدیر',
    },

    common: {
      removeChat: 'حذف گفت‌وگو',
      clearHistory: 'پاک‌سازی تاریخچه',
      markAsRead: 'علامت زدن به عنوان خوانده شده',
      markAsUnread: 'علامت زدن به عنوان خوانده نشده',
      copy: 'کپی',
      select: 'انتخاب',
      share: 'به اشتراک گذاری',
      report: 'گزارش محتوای نامناسب',
      remove: 'حذف',
    },

    call: {
      getAttendanceReport: 'لیست شرکت‌کنندگان',
    },
    admin: { editRights: 'تغییر', dismissAdmin: 'صرف نظر' },
    removedUser: {
      addToChannel: 'افزودن به کانال',
      addToGroup: 'افزودن به گروه',
      delete: 'حذف از فهرست',
    },
    inviteLink: {
      edit: 'ویرایش لینک',
      revoke: 'باطل کردن لینک',
      remove: 'حذف لینک',
    },
  },
  navigationBar: {
    chat: 'گفتگو',
    backpack: 'کوله',
    movement: 'حرکت',
    stream: 'جریان',
    stations: 'موکب‌ها',

    workInProgress: 'این صفحه در حال توسعه است و به زودی از آن رونمایی می‌شود!',
  },

  JoinHallRequests: {
    requestsBarTitle: (count: number, type) =>
      `${toLocale(count, false)} درخواست برای عضویت در ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      }`,
    list: {
      title: 'درخواست عضویت',
      emptyText: type =>
        `درخواستی برای عضویت در ${
          type === 'CHANNEL' ? 'کانال' : 'گروه'
        } وجود ندارد`,
      requestedToJoinAt: 'درخواست داده شده در',
      errorText: 'دریافت لیست درخواست‌ها با مشکل مواجه شد',
    },
  },

  appBar: {
    search: 'جستجو...',
  },

  story: {
    nStories: n => `${n} ماجرا`,
    addStory: 'افزودن ماجرا',
    yourStory: 'ماجرای شما',
    createStoryModal: {
      chooseOneOfBelowOptions: 'یکی از گزینه‌های زیر را انتخاب کنید',
      storyTypes: {
        image: 'عکس',
        video: 'فیلم',
      },
      submit: 'تایید و ارسال',
    },
    viewStoryModal: {
      addStory: 'افزودن ماجرا',
      deleteStory: 'حذف ماجرا',
    },
    deleteStoryModal: {
      title: 'حدف ماجرا',
      description: 'آیا از حذف این ماجرا اطمینان دارید؟',
    },
    noViewedYet: 'هنوز بازدیدی ثبت نشده است',
    sending: 'در حال ارسال',
  },

  syncIOSAccounts: {
    onboarding: {
      title:
        'برای دسترسی به مخاطبین جریان در iOS، باید از این طریق مخاطبین خود را انتخاب کنید.',
    },
    fabButtonLabel: 'بروزرسانی مخاطبین',
    nContactsDoesntHaveAppAccount: n =>
      `${toLocale(
        n,
        false,
      )} مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارند`,
    selectedContactDoesntHaveAppAccount: `مخاطب انتخاب شده در ${APP_NAME} حساب کاربری ندارد`,
    xAddedToContacts: name => `«${name}» به مخاطبین اضافه شد`,
    xAndNPersonsAddedToContacts: (name, n) =>
      `«${name}» و ${toLocale(n, false)} نفر دیگر به مخاطبین اضافه شدند`,
    howToEnableSyncDialog: {
      title: `برای دسترسی به مخاطبین ${APP_NAME} در iOS، ابتدا باید مراحل زیر را انجام دهید:`,
      steps: {
        first: 'وارد Settings گوشی خود شوید.',
        second: 'از بین برنامه‌ها Safari را انتخاب کنید.',
        third: 'در انتهای صفحه Advanced را انتخاب کنید.',
        fourth: 'گزینه Feature Flags را انتخاب کنید.',
        fifth: 'گزینه Contact Picker API را فعال کنید.',
        sixth: `برنامه ${APP_NAME} را کامل بسته و مجدد باز کنید.`,
      },
      confirm: 'متوجه شدم',
    },
  },

  profile: {
    hall: {
      deletedChannel: 'کانال حذف شده',
      deletedGroup: 'گروه حذف شده',
      inviteLink: 'لینک دعوت',
      description: 'توضیحات',
      subscriber: 'مشترک',
      member: 'عضو',
      channelName: 'عنوان کانال',
      groupName: 'عنوان گروه',
      enterChannelName: 'عنوان کانال را وارد کنید',
      enterGroupName: 'عنوان گروه را وارد کنید',
      enterChannelDescription: 'توضیحات مربوط به کانال را وارد کنید',
      enterGroupDescription: 'توضیحات مربوط به گروه را وارد کنید',
      noDescription: 'توضیحاتی وجود ندارد',
      channelVitrine: 'ویترین کانال',
      options: {
        type: {
          groupType: 'نوع گروه',
          channelType: 'نوع کانال',
          private: 'خصوصی',
          public: 'عمومی',
        },
        historyForNewMembers: {
          title: 'تاریخچه گفت‌وگو برای اعضای جدید',
          visible: 'قابل مشاهده',
          hidden: 'پنهان',
        },
      },
      actions: {
        inviteViaLink: 'دعوت از طریق لینک',
        setting: 'تنظیمات',
        addMember: 'افزودن عضو',
        joinChannel: 'پیوستن به کانال',
        joinGroup: 'پیوستن به گروه',
        subscribers: 'مشترکین',
        members: 'اعضای گروه',
        admins: 'مدیران',
        addSubscriber: 'افزودن مشترک',
        membersPermissions: 'اختیارات اعضا',
        inviteLinks: 'لینک‌های دعوت',
        removedUsers: 'کاربران حذف شده',
        joinRequests: 'درخواست‌های عضویت',
      },
      criticalActions: {
        deleteChannel: 'حذف کانال',
        deleteGroup: 'ترک و حذف گروه',
      },
      removeUsers: { title: 'حذف کاربر', removedBy: 'حذف شده توسط' },
      joinedViaLink: {
        title: 'افراد پیوسته از طریق لینک',
      },
    },
    user: {
      sendMessage: 'ارسال پیام',
      block: 'مسدود کردن کاربر',
      unblock: 'رفع مسدودیت کاربر',
      deleteContact: 'حذف مخاطب',
      addToContacts: 'افزودن به مخاطبین',
      deleteConversation: 'حذف گفت‌وگو',
      clearHistory: 'پاک کردن تاریخچه',
    },
    wapp: {
      sendMessage: 'مشاهده‌ی گفت‌وگو',
      tool: 'ابزار',
    },
    common: {
      sharedMedia: 'رسانه‌های اشتراکی',
    },
    notification: {
      active: 'فعال',
      passive: 'غیرفعال',
    },
  },
  multiTab: {
    refresh: 'فعال کردن این صفحه',
    error: 'این صفحه غیرفعال شد',
    description:
      'شما صفحه دیگری از برنامه را باز کرده‌اید. بنابراین برای جلوگیری از مشکلات احتمالی، ما این صفحه را غیرفعال کرده‌ایم.',
  },
  myAccount: {
    account: 'حساب کاربری',
    version: version => `نسخه ${version}`,
    contact: 'مخاطبین',
    contactUs: 'ارتباط با ما',
    balance: 'اطلاعات مالی',
    credit: 'اعتبار:',
    savedMessage: 'پیام‌های ذخیره شده',
    inviteFriends: 'دعوت از دوستان',
    support: 'پشتیبانی',
    logout: 'خروج',
    addUserName: 'برای این حساب نام کاربری انتخاب کنید',
    addBio: 'خودتان را کوتاه معرفی کنید',
    blockedUsers: {
      block: 'مسدود کردن کاربر', // TODO: Merge block titles
    },
    faq: 'سوالات متداول',
    q1: {
      title: 'پلتفرم جریان چیست؟',
      description:
        'جریان یک پلتفرم بر پایه پیام‌رسان است که به منظور شبکه‌سازی، هم‌افزایی و سازماندهی گروه‌ها و مجموعه‌هاست. این پلتفرم علاوه بر قابلیت‌های متداول پیام‌رسانی، ابزارهای متعددی همچون ابزارهای ارتباطی (پخش زنده، تریبون، جلسه و تماس یک‌به‌یک)، نویسه، نظرسنجی، فرم، آزمون تستی و … فراهم کرده است تا به کمک آن عمده نیازهای کاربران برطرف گردد.',
    },
    q2: {
      title: 'چگونه جریان را روی موبایل و تبلت نصب کنم؟',
      description:
        'در حال حاضر تنها نسخه اندروید وجود دارد که آخرین نسخه آن را از آدرس https://jaryan.app/dl می‌توانید دریافت نمایید.\n' +
        '\n' +
        'برای سیستم‌عامل‌های دیگر مثل iOS، ویندوز، macOS و لینوکس می‌توانید از نسخه PWA که در آدرس https://jaryan.app قرار دارد، استفاده نمایید.',
    },
    q3: {
      title: 'چگونه جریان را روی کامپیوتر شخصی داشته باشم؟',
      description:
        'برای دسترسی به جریان روی کامپیوتر شخصی و لپ تاپ می‌توانید از نسخه وب جریان که در آدرس  https://jaryan.app وجود دارد استفاده نمایید.',
    },
    q4: {
      title: 'چگونه گروه یا کانال ایجاد کنم؟',
      description:
        'در صفحه گفت‌گو بر روی آیکون مداد کلیک نمایید و از لیست موجود گزینه ایجاد گروه یا ایجاد کانال را انتخاب نمایید. سپس در صفحه بعدی می‌بایست مشخصات گروه یا کانال که شامل نام، نوع، شناسه و توضیحات است را وارد کنید. در مرحله بعد مخاطبینی که تمایل دارید در گروه یا کانال شما عضو شوند را از لیست مخاطبان انتخاب نموده و با تایید نهایی گروه یا کانال مدنظر شما ایجاد می‌گردد.',
    },
    q5: {
      title: 'چگونه مطلع شوم چه دستگاه‌هایی به اکانت من متصل هستند؟',
      description:
        'برای اطلاع از لیست دستگاه‌های فعال؛ کافی است وارد بخش تنظیمات شده و از زیربخش امنیت، گزینه دستگاه‌های فعال را انتخاب نمایید. در صفحه جدید میتوانید لیست کاملی از دستگاه‌های متصل به حساب کاربری خود را مشاهده نمایید.\n' +
        '\n' +
        'اگر دستگاهی متعلق به شما نبود و در لیست قرار داشت، می‌توانید به آسانی و با انتخاب حذف دستگاه؛ این دستگاه ناشناس را از لیست دستگاه‌های فعال حذف نمایید تا دسترسی آن به حساب کاربری شما بسته شود.',
    },
    q6: {
      title: 'آیا شماره تلفن من برای دیگران قابل مشاهده است؟',
      description:
        'شماره تلفن همراه شما برای هیچ کس قابل مشاهده و دسترسی نیست؛ مگر اینکه از قبل شماره تلفن همراه شما را ذخیره داشته باشند.',
    },
    q7: {
      title: 'چگونه یک کاربر را به لیست سیاه اضافه نمایم؟',
      description:
        'بعد از ورود به صفحه مکالمات با شخص مورد نظر؛ روی نام مخاطب در بالای صفحه کلیک نمایید تا صفحه پروفایل کاربر باز شود. از طریق منویی که در بالا سمت چپ باز می‌شود، می‌توانید گزینه مسدود کردن کاربر را بزنید. در ضمن از بخش حریم خصوصی صفحه تنظیمات می‌توانید، کاربران مسدود شده خود را مدیریت کنید.',
    },
    q8: {
      title:
        'چگونه دانلود خودکار تصاویر، ویدئوها، صوت، آهنگ و فایل را فعال یا غیرفعال نمایم؟',
      description:
        'برای مدیریت و کنترل دانلود خودکار، بعد از ورود به بخش تنظیمات، از زیربخش داده‌ها و ذخیره‌سازی، می‌توانید گزینه دانلود خودکار رسانه‌ها را فعال یا غیرفعال نمایید.',
    },
    q9: {
      title: 'چگونه می توانم کش مربوط به پلتفرم جریان را خالی کنم؟',
      description:
        'بعد از ورود به بخش تنظیمات؛ از زیربخش داده‌ها و ذخیره‌سازی، روی گزینه پاک کردن حافظه موقت بزنید تا حافظه را حذف و خالی نمایید.',
    },
  },
  contactUs: {
    address: {
      title: 'آدرس',
      description: 'تهران، ستارخان، باقرخان، گناباد، پلاک ۴۶، واحد ۱۰',
    },
    email: {
      title: 'ایمیل',
      description: 'info@weblite.im',
    },
    phone: {
      title: 'تلفن',
      description: '02166574375',
    },
  },
  myAccountEdit: {
    save: 'ذخیره',
    pleaseSelect: 'لطفاً انتخاب کنید...',
    birthDate: 'تاریخ تولد',
    gender: 'جنسیت',
    return: 'بازگشت',
  },
  settings: {
    title: 'تنظیمات',
    sections: {
      notification: {
        title: 'اعلان‌ها',
        mute: 'بی‌صدا کردن اعلان‌ها',
      },
      privacy: {
        title: 'حریم خصوصی',
        blockedUsers: 'کاربران مسدود شده',
      },
      contacts: {
        sync: 'همگام سازی خودکار مخاطبین',
        repetitiveContacts: 'پیشنهاد مخاطبین پرتکرار',
        deleteSyncContacts: 'حذف مخاطبین همگام سازی شده',
        reloadContacts: 'بارگذاری مجدد مخاطبین',
      },
      storage: {
        title: 'داده‌ها و ذخیره‌سازی',
        clearStorage: 'پاک کردن حافظه‌ی موقت',
        description: 'پاک‌سازی اطلاعات دانلود شده از دستگاه شما',
        autoDownload: 'دانلود خودکار رسانه‌ها',
        autoPlay: 'پخش پیوسته فایل‌های صوتی',
      },
      language: {
        title: 'زبان',
        selectedLanguage: 'زبان انتخاب شده',
        choiceLanguage: 'انتخاب زبان',
        persian: 'فارسی',
        arabic: 'العربیة',
        english: 'انگلیسی',
      },
      security: { title: 'امنیت', activeDevices: 'دستگاه‌های فعال' },
    },
    privacy: {
      questions: {
        phone: 'چه کسی می‌تواند شماره‌ی همراه من را ببیند؟',
        status: 'چه کسی می‌تواند زمان آخرین بازدید شما را ببیند؟',
        link_via_forward:
          'چه کسی می‌تواند در هنگام ارسال پیام‌های من، لینکی به حساب کاربری من اضافه کند؟',
        image: 'چه کسی می‌تواند عکس حساب من را ببیند؟',
        add_hall: 'چه کسی می‌تواند من را عضو گروه‌ها و کانال‌ها کند؟',
      },
      type: {
        phone: 'شماره‌ی همراه',
        status: 'آخرین بازدید و آنلاین بودن',
        link_via_forward: 'ارسال پیام شما به دیگران',
        image: 'عکس حساب شما',
        add_hall: 'پیوستن به گروه‌ها و کانال‌ها',
      },
      policy: {
        exceptions: (include: number, exclude: number) =>
          include || exclude
            ? ` (${exclude ? `${toLocale(exclude)}-` : ''}${
                include && exclude ? ',' : ''
              }${include ? `${toLocale(include)}+` : ''})`
            : '',
        every_body: 'همه',
        no_body: 'هیچ‌کس',
        contacts: 'مخاطبین من',
      },
      exception: {
        exceptionCount: (count: number) => `${toLocale(count)} کاربر`,
        add: 'افزودن استثناها',
        always: 'همیشه اجازه داده شود',
        never: 'هرگز اجازه داده نشود',
        addUsers: 'افزودن کاربران',
        exceptions: 'استثناها',
        set: 'تنظیم استثناها',
      },
    },
    deleteAccount: {
      title: 'حذف حساب کاربری',
      description:
        'برای حذف حساب کاربری ابتدا باید کد تایید ارسال شده به تلفن همراه خود را وارد کنید.',
      confirm: 'ارسال کد تایید',
      verification: {
        title: 'کد تایید را وارد کنید',
        desc: (phone: number) =>
          `کد تایید حذف حساب کاربری به شماره ${phone} ارسال شده است`,
        confirm: 'حذف حساب کاربری',
      },
    },
  },
  contacts: {
    add: 'افزودن مخاطب',
    phonePlaceholder: '۹۱۲۳۴۵۶۷۸۹',
    editContact: 'ویرایش مخاطب',
    newContact: 'مخاطب جدید',
  },
  auth: {
    title: `${APP_NAME}،‌ مسیر خوب زندگی`,
    sliders: {
      pass: 'ورود',
      next: 'بعدی',
      enter: `وارد ${APP_NAME} شوید`,
      first: {
        title: `به ${APP_NAME} بپیوندید`,
        description:
          'جریانی که در اون قراره حصر رسانه‌ای دشمن شکسته بشه ان‌شاءالله',
      },
      second: {
        title: 'حرکت در جهت شکست حصر رسانه‌ای دشمن',
        description:
          'حرکت شما در جریان مشابه پیاده‌روی اربعینه ولی در این مسیر مانع و دشمن وجود داره‌. اینجا باید در این به صورت جمعی حرکت کنید، منتها در فضای مجازی',
      },
      third: {
        title: 'موکب‌های مسیر',
        description:
          'در این مسیر، موکب‌های مختلف تسهیل‌گر و پشتیبان حرکت شما هستند و لوازم حرکت شما را فراهم می‌کنند',
      },
    },
    startingPage: 'ورود یا ثبت نام',
  },
  armanema: {
    // #moghavemat
    notifBlocked: {
      title: 'اعلان‌ها غیر فعال است',
      description:
        'شما دسترسی به اعلان‌ها را "Block" کرده‌اید. برای با خبر شدن از اطلاع‌رسانی‌های مهم رویداد، اعلان‌ها را فعال کنید.',
      button: 'مشاهده نحوه فعال سازی',
    },
    notifActivation: {
      title: 'فعال سازی اعلان‌ها',
      description:
        'برای با خبر شدن از اطلاع‌‌رسانی‌های مهم رویداد، در پنجره‌ باز شده در ادامه، گزینه "Allow" را بزنید',
    },
  },
  completeProfile: {
    infoBox: 'این اطلاعات در گواهی پایان دوره شما استفاده خواهد شد.',
    fatherName: 'نام پدر',
    enterFatherName: 'نام پدر خود را وارد کنید',
    nationalCode: 'کد ملی',
    enterNationalCode: 'کد ملی خود را وارد کنید',
    specialities: 'حیطه تخصصی (حداکثر ۲ مورد) ',
    errors: {
      'repetitive-national-id': 'کد ملی تکراری است',
      'invalid-national-id': 'کد ملی صحیح نیست',
      'least-ten-number': 'کد ملی باید ده رقم باشد',
    },
    network: 'شبکه',
    enterNetwork: 'شبکه خود را انتخاب کنید',
    justUseLetters: 'تنها مجاز به استفاده از حروف هستید',
  },
  signin: {
    title: `ورود به ${APP_NAME}`,
    enterPhone: 'شماره‌ی تلفن همراه خود را وارد کنید',
    confirm: 'ادامه',
    checkboxOption: 'همگام سازی خودکار مخاطبین',
    verification: {
      title: 'کد تایید',
      edit: 'اصلاح',
      resendCode: 'ارسال مجدد کد تایید',
      validTillXMore: 'معتبر تا {{x}} دیگر',
      enterCode: 'کد ۵ رقمی ارسالی را وارد کنید:',
      wrongCodeEntered: 'کد وارد شده اشتباه است',
      maxTriesReached: 'حداکثر دفعات تلاش انجام شد. لطفاً از اول تلاش کنید',
      signupClosed: 'ثبت نام بسته شده است',
      inputPlaceholder: 'کد تایید ۵ رقمی...',
      description: () =>
        boldSome(
          'کد تایید که از طریق',
          '«پیامک»',
          'دریافت کرده‌اید را وارد کنید.',
        ),
      syncDeviceCode: () =>
        boldSome(
          'کد تایید به دستگاه متصلتان به ',
          '«جریان»',
          'ارسال شد لطفا آن را وارد کنید.',
        ),
    },
    serverCodes: {
      INVALID_PHONE: 'شماره تلفن وارد شده صحیح نیست، دوباره تلاش کنید.',
      FAILED_DELIVERY:
        'سامانه پیامکی‌مون بد قولی کرده، لطفاً دوباره امتحان کنید.',
      BANNED: 'شما مجاز به ورود نیستید',
      NOT_INVITED: 'شما هنوز دعوت نشده‌اید',
      NOT_IN_WHITELIST: 'شما مجوز ورود به سامانه را ندارید.',
    },
  },
  addAdmin: {
    title: 'افزودن مدیر',
  },
  memberList: {
    title: 'لیست اعضا',
  },
  addMembers: {
    title: 'افزودن اعضا',
    joinedAt: {
      prefix: 'در تاریخ',
      postfix: 'پیوست',
    },
  },
  removeMembers: {
    title: 'حذف اعضا',
  },
  multiSelectUserList: {
    noUserSelected: 'کاربری انتخاب نشده‌است',
  },
  admins: {
    title: 'مدیران',
    addAdmin: 'افزودن مدیر',
    promotedBy: 'ارتقا یافته توسط',
  },
  signup: {
    title: `ثبت نام در ${APP_NAME}`,
    withSigningUp: `با ثبت نام در ${APP_NAME}، شما `,
    haveReadAndAccept: ' آن را می‌پذیرید.',
    emptyName: 'نام نباید خالی باشد',
    shouldAddReferrerCode:
      'شما به جریان دعوت نشده‌اید. برای ورود باید کد معرف خود را وارد کنید.',
    referrerCode: 'کد معرف',
    insertReferrerCode: 'کد معرف خود را وارد کنید',
    errorCode: {
      CODE_REQUIRED: 'وارد کردن کد اجباری است',
      CODE_EXPIRED: 'کد منقضی شده است',
      CODE_NOT_FOUND: 'کد مورد نظر در سیستم تعریف نشده است',
      CODE_REVOKED: 'کد غیرفعال شده است',
    },
  },
  phoneInput: {
    errorMessage: 'وارد کردن این ورودی الزامی است',
  },
  linkInput: {
    infoMessage: 'در حال بررسی نام...',
    errorMessage: 'این نام نامعتبر است',
    successMessage: 'این نام معتبر است',
  },
  loadingModal: {
    messages: 'در حال بارگیری پیام‌ها...',
    saveChanges: 'در حال ثبت تغییرات...',
    loadFromServer: 'در حال دریافت اطلاعات از سرور...',
    processingMessage: 'در حال پردازش پیام...',
    sharedMedia: 'در حال بارگیری محتواها...',
    wappOverlay: 'در حال اجرای وپ...',
  },
  changelogModal: {
    title: 'تغییرات نسخه جدید',
    version: 'نسخه',
    features: 'قابلیت‌های جدید',
    improvements: 'بهبود‌ها',
    bugs: 'رفع باگ‌ها',
  },
  completeProfileModal: {
    title: (name: string) => `ثبت نام در رویداد ${name}`,
    description: (name: string) =>
      `برای شرکت در رویداد ${name} لازم است که اطلاعات ثبت‌نامی خود را تکمیل نمایید.`,
  },
  verificationCodeInput: {
    errorMessage: 'کد وارد شده اشتباه است',
  },
  editUsername: {
    descriptionBox: `نام باید حداقل ۵ کاراکتر باشد و باید با حرف انگلیسی شروع شود.\nمی‌تواند شامل حروف و اعداد انگلیسی و '_' باشد.`,
  },
  editBio: {
    descriptionBox:
      'این متن در پروفایل شما نمایش داده می‌شود. شما می‌توانید چند خط در مورد خودتان بنویسید.',
  },
  hallPermissionsPage: {
    common: {
      pinMessages: 'سنجاق کردن پیام‌ها',
      sendWapp: 'ارسال ابزار',
      noPermissionToSendWapp: 'شما اجازه ارسال برنامه را ندارید',
    },
    channelAdminRights: {
      title: 'اختیارات مدیر',
      subTitle: 'این مدیر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'برکناری مدیر',
      secondaryButtonText: 'انتقال مالکیت کانال',
      changeHallInfo: 'تغییر اطلاعات کانال',
      editMessage: 'ویرایش پیام‌ها',
      deleteMessages: 'حذف پیام‌های دیگران',
    },
    groupMemberPermissionsOverride: {
      title: 'اختیارات کاربر',
      subTitle: 'این کاربر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'حذف از گروه',
      sendMessage: 'ارسال پیام متنی',
    },
    groupMemberPermissions: {
      title: 'اختیارات اعضا',
      subTitle: 'اعضای گروه چه کارهایی می‌توانند انجام دهند؟',
      actionButtonText: 'مشاهده و تنظیم استثناها',
      addMembers: 'افزودن اعضای جدید',
      changeHallInfo: 'تغییر اطلاعات گروه',
      sendMessage: 'ارسال پیام متنی',
      sendMedia: 'ارسال چندرسانه‌ای',
    },
    groupAdminRights: {
      title: 'اختیارات مدیر',
      subTitle: 'این مدیر چه کارهایی می‌تواند انجام دهد؟',
      actionButtonText: 'برکناری مدیر',
      secondaryButtonText: 'انتقال مالکیت گروه',
      addNewAdmins: 'افزودن مدیران جدید',
      banUsers: 'محروم کردن کاربران',
      changeHallInfo: 'تغییر اطلاعات گروه',
      deleteMessages: 'پاک کردن پیام‌ها',
      inviteViaLink: 'دعوت به وسیله لینک دعوت',
    },
  },
  hallAccessibility: {
    linkPlaceHolder: 'نام لینک',
    hallSetting: {
      group: 'تنظیمات گروه',
      channel: 'تنظیمات کانال',
      educationalChannel: 'تنظیمات کانال آموزشی',
      mookebChannel: 'تنظیمات موکب',
    },
    type: {
      group: 'نوع گروه',
      channel: 'نوع کانال',
    },
    access: {
      public: {
        group: {
          title: 'گروه عمومی',
          description:
            'گروه‌های عمومی در نتایج جست‌و‌جو پیدا می‌شوند و هر کسی می‌تواند به آن‌ها بپیوندد.',
        },
        channel: {
          title: 'کانال عمومی',
          description:
            'کانال‌های عمومی در نتایج جست‌و‌جو پیدا می‌شوند و هر کسی می‌تواند به آن‌ها بپیوندد.',
        },
      },
      private: {
        group: {
          title: 'گروه خصوصی',
          description:
            'تنها از طریق لینک دعوت می‌توان به گروه‌های خصوصی پیوست.',
        },
        channel: {
          title: 'کانال خصوصی',
          description:
            'تنها از طریق لینک دعوت می‌توان به کانال‌های خصوصی پیوست.',
        },
      },
    },
    link: {
      public: 'لینک عمومی',
      private: 'لینک دعوت',
    },
    publicLinkHint: {
      legalCharacters: 'شما می‌توانید از کاراکترهای 9-0، a-z و _ استفاده کنید.',
      minimumLength: 'حداقل طول مجاز ۵ کاراکتر است.',
    },
  },
  newChatModal: {
    newChat: 'گفت‌وگوی جدید',
    createChannel: 'ایجاد کانال',
    createGroup: 'ایجاد گروه',
    myContacts: 'مخاطبین من',
  },
  createEducationalChannel: {
    vitrine: {
      title: 'فهرست دوره',
      description:
        'ابزار نظم دهی و دسته بندی به محتواهای کانال به منظور ایجاد دسترسی بهتر',
    },
    issue: {
      title: 'رفع اشکال',
      description:
        'ابزار ارتباطی مخاطبین با ادمین کانال. سوالات کاربران را دریافت کنید و یا از آن‌ها سوال بپرسید.',
    },
  },
  forceUpdateWeb: {
    title: 'بروزرسانی فوری',
    description:
      'نسخه فعلی دیگر پشتیبانی نمی‌گردد. برای جلوگیری از بروز مشکلات احتمالی، لطفا وارد نسخه جدید شوید.',
    actionButton: 'ورود به نسخه جدید',
    receivingUpdate: 'در حال دریافت نسخه جدید',
    updateReceived: 'بروزرسانی دریافت شد',
  },
  sendInviteLink: {
    title: 'ارسال لینک دعوت',
    description: (isGroup: boolean) =>
      `برخی مخاطبین، دسترسی عضویت در ${
        isGroup ? 'گروه' : 'کانال'
      } را محدود کرده‌اند. در عوض شما می‌توانید برایشان لینک دعوت ارسال کنید.`,
    shouldUnban: (count: number) =>
      `${count} نفر از افراد مسدود شده‌اند. برای عضویت آن‌ها باید ابتدا مدیر آن‌ها را رفع مسدودیت کند.`,
    inviteText: (sender: string, isGroup: boolean, inviteLink: string) =>
      `${sender} شما را برای پیوستن به ${
        isGroup ? 'گروه' : 'کانال'
      } زیر دعوت کرده است\n ${inviteLink}`,
  },
  inviteLinks: {
    common: {
      inviteLink: 'لینک دعوت',
      expiredLink: 'لینک منقضی شده',
      oneHour: '۱ ساعت',
      oneDay: '۱ روز',
      oneWeek: '۱ هفته',
      unlimited: 'نامحدود',
      today: 'امروز',
      createLink: 'ایجاد لینک',
      editLink: 'ویرایش لینک',
    },
    modal: {
      linkIsCreatedBy: 'ایجاد شده توسط',
      joinedUser: 'مشاهده‌ی افرادی که از طریق لینک عضو شدند',
    },
    create: {
      needsApproval: {
        title: 'تائید اعضای جدید',
        desc: 'کاربران جدید نمی‌توانند بدون تایید ادمین به کانال بپیوندند.',
      },
      timeLimit: {
        subheader: 'محدود کردن بر اساس مدت زمان',
        description:
          'شما می‌توانید مشخص کنید که لینک پس از مدت زمان مشخصی منقضی شود.',
        inputPlaceholder: 'مدت زمان دلخواه را تنظیم کنید...',
      },
      usageLimit: {
        subheader: 'محدود کردن بر اساس تعداد استفاده',
        description:
          'شما می‌توانید مشخص کنید که لینک پس از دفعات استفاده‌ی مشخصی منقضی شود.',
        inputPlaceholder: 'تعداد استفاده‌ی دلخواه را تنظیم کنید...',
      },
    },
    list: {
      createNewLink: 'ایجاد لینک جدید',
      revoked: 'باطل شده',
      isExpired: 'منقضی شده‌است',
      limitReached: 'به سقف مجاز رسیده‌است',
      dayIsRemaining: 'روز باقی مانده‌است',
      lessThanOneDayIsRemaining: 'کمتر از یک روز باقی مانده است',
      noOneHasJoined: 'هیچ‌کس نپیوست',
      noOneHasJoinedYet: 'هنوز کسی نپیوسته‌است',
      oneJoined: 'نفر پیوستند',
      oneCanJoin: 'نفر می‌توانند بپیوندند',
      inviteLinks: 'لینک‌های دعوت',
      createdLinks: 'لینک‌های ایجاد شده',
      revokedLinks: 'لینک‌های باطل شده',
      deleteAllRevokedLinks: 'حذف تمامی لینک‌های باطل شده',
      noLink: 'لینکی وجود ندارد',
    },
  },
  chatList: {
    privateSpace: 'پیام‌های ذخیره شده',
    draft: 'پیش‌نویس:',
    tooManyUnseen: '۹۹+',
    menu: {
      pin: 'سنجاق کردن',
      unPin: 'برداشتن سنجاق',
      addHallToWorkspace: 'افزودن به فضای اختصاصی',
      removeHallFromWorkspace: 'انتقال به چت لیست عمومی',
    },
    tabs: {
      channel: 'کانال‌ها',
      group: 'گروه‌ها',
      pv: 'شخصی',
      all: 'همه',
      wappRoom: 'ابزارها',
      workspaces: 'فضای اختصاصی',
    },
  },
  sharedMedia: {
    media: 'رسانه',
    link: 'لینک',
    voice: 'صوت',
    audio: 'موسیقی',
    file: 'فایل',
  },
  chatAppBar: {
    title: 'گفت‌و‌گو',
  },
  selectWorkspaceName: {
    title: 'ایجاد فضای اختصاصی',
    edit: 'ویرایش فضای اختصاصی',
    name: 'نام فضای اختصاصی',
    placeholder: 'نام فضای اختصاصی را وارد کنید',
    confirm: 'مرحله بعد',
  },
  selectWorkspaceColor: {
    back: 'مرحله قبل',
    confirm: 'ایجاد',
  },
  selectWorkspace: {
    title: 'فضای اختصاصی مورد نظر را انتخاب کنید',
  },

  forwardAppBar: {
    title: 'ارسال به...',
    receiver: (num: number) => `${toLocale(num)} دریافت کننده`,
  },
  chatListSearch: {
    globals: 'جستجوهای سراسری',
    recent: 'جستجو‌های اخیر',
    deleteAll: 'حذف همه',
  },
  emptyChatList: {
    title: 'گفت‌وگو‌های شما در اینجا نمایش داده می‌شود',
    description:
      'با زدن دکمه زیر یا از طریق جست‌و‌جو به وسیله دکمه‌ی بالای صفحه گفت‌و‌گو را شروع کنید',
  },
  joinHallDialog: {
    joinChannel: 'پیوستن به کانال',
    joinGroup: 'پیوستن به گروه',
  },
  emptyState: {
    noUserFound: 'کاربری یافت نشد',
    noContactFound: `شما هنوز مخاطبی در ${APP_NAME} ندارید...`,
    noResultFound: 'نتیجه‌ای یافت نشد',
    noContentFound: 'محتوایی یافت نشد',
    searchHint: 'برای جست‌و‌جوی بهتر، در وارد کردن کلمات دقت کنید',
    noMessages: 'هنوز پیامی در اینجا نیست...',
  },
  errorState: {
    default: 'در دریافت اطلاعات مشکلی بوجود امده است',
  },
  installTwa: {
    recommend: {
      title: 'دریافت اپلیکیشن جریان',
      description:
        'برای استفاده بهتر از پلتفرم جریان، لطفا نسخه اندروید را نصب بفرمایید.',
    },
    force: {
      title: 'دریافت اپلیکیشن جریان',
      description:
        'برای استفاده بهتر از پلتفرم جریان، باید نسخه اندروید را نصب بفرمایید.',
    },
  },
  datePickerModal: {
    inviteLinkExpireDate: {
      title: 'انتخاب زمان',
    },
    birthdate: {
      title: 'انتخاب تاریخ تولد',
    },
  },

  confirmDialog: {
    addHallToWorkspace: {
      title: 'افزودن به فضای اختصاصی',
      description: (count: number, workspaceName: string) =>
        `آیا از افزودن این  ${toLocale(count)} مورد به فضای اختصاصی «${workspaceName}» اطمینان دارید؟`,
      confirmOption: 'افزودن',
      cancelOption: 'لغو',
    },
    removeHallFromWorkspace: {
      title: 'انتقال به چت لیست عمومی',
      description: (count: number) =>
        `آیا از انتقال این  ${toLocale(count)} مورد به چت لیست عمومی اطمینان دارید؟`,
      confirmOption: 'انتقال',
    },
    deleteWorkspace: {
      title: 'حذف فضای اختصاصی',
      description: 'آیا از حذف فضای اختصاصی اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    reloadContacts: {
      description: 'آیا از بارگذاری مجدد مخاطبین اطمینان دارید؟',
    },
    deleteSyncedContacts: {
      description: () =>
        boldSome(
          'با این کار مخاطبین شما از سرور های جریان حذف خواهد شد . در صورتی که «',
          'همگام سازی مخاطبین',
          '» فعال باشد، دفترچه تلفن فعلی شما مجدداً همگام سازی خواهد شد.',
        ),
    },
    callInIos: {
      description:
        'قابلیت تماس در سیستم عامل ios پشتیبانی نمی‌شود. لطفا برای استفاده از این قابلیت، از سیستم‌عامل‌های دیگر استفاده نمایید.',
    },
    banUser: {
      description: {
        prefix: 'آیا از حذف',
        postfix: 'اطمینان دارید؟',
      },
      title: 'حذف کاربر',
      cancelOption: 'لغو',
      confirmOption: 'حذف کاربر',
    },
    discardChanges: {
      title: 'تغییرات اعمال شود؟',
      description: 'شما برخی از تنظیمات را تغییر داده‌اید. تغییرات اعمال شود؟',
      confirmOption: 'اعمال',
      cancelOption: 'خیر',
    },
    deleteScheduledCall: {
      title: type => `حذف زمان‌بندی ${type}`,
      description: type => `آیا از حذف زمان‌بندی این ${type} اطمینان دارید؟`,
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    startScheduledCall: {
      title: type => `شروع ${type}`,
      description: type => `آیا از شروع همین الان ${type} اطمینان دارید؟`,
      confirmOption: 'شروع همین الان',
      cancelOption: 'لغو',
    },
    deleteStory: {
      title: 'حذف ماجرا',
      description: 'آیا از حذف این ماجرا اطمینان دارید؟',
      confirmOption: 'حذف',
      cancelOption: 'لغو',
    },
    addMember: {
      newMembersGreaterThan3: (text: string) => `${text} عضو`,
      title: (count: string) => `افزودن ${count}عضو`,
      confirmOption: 'افزودن عضو',
      cancelOption: 'لغو',
      description: {
        prefix: 'آیا از افزودن',
        postfix: {
          prefix: 'به',
          postfix: 'اطمینان دارید؟',
        },
      },
    },
    deleteChat: {
      title: (count: number) => `حذف ${toLocale(count)} گفت‌و‌گو`,
      description: 'آیا از حذف این گفت‌و‌گوها اطمینان دارید؟',
      confirmOption: 'حذف گفت‌وگوها',
    },
    deletePv: {
      title: 'حذف گفت‌و‌گو',
      confirmOption: 'حذف گفت‌وگو',
      cancelOption: 'لغو',
      description: {
        prefix: 'آیا از حذف گفت‌و‌گوی',
        postfix: 'اطمینان دارید؟',
      },
      checkboxOption: 'تاریخچه‌ برای شما پاک شود',
    },
    clearPVHistory: {
      title: 'پاک کردن تاریخچه',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
      description: {
        prefix: 'آیا از پاک کردن تاریخچه‌ی گفت‌و‌گوی خود با',
        postfix: 'اطمینان دارید؟',
      },
      moreThan3: (text: string) => `${text} گفت‌گو`,
    },
    clearSearchHistory: {
      title: 'پاک کردن تاریخچه‌ی جست‌وجو',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
      description: 'آیا از پاک کردن تاریخچه‌ی جست‌وجو اطمینان دارید؟',
    },
    deleteMessage: {
      description: {
        oneMessage: (text: string) =>
          `آیا از حذف پیام ${text || ''}اطمینان دارید؟`,
        manyMessage: (text: string) =>
          `آیا از حذف پیام‌های انتخاب شده ${text}اطمینان دارید؟`,
        forGroup: 'برای خود و اعضای گروه ',
        forPv: (name: string) => `برای خود و ${name} `,
      },
      title: {
        oneMessage: 'حذف پیام',
        manyMessage: (text: string) => `حذف ${text} پیام`,
      },
      cancelOption: 'لغو',
      confirmOption: 'حذف',
    },
    deleteContact: {
      description: 'آیا از حذف این مخاطب اطمینان دارید؟',
      title: 'حذف مخاطب',
      cancelOption: 'لغو',
      confirmOption: 'حذف',
    },
    leaveHall: {
      description: {
        prefix: 'آیا از ترک',
        postfix: 'اطمینان دارید؟',
      },
      title: (text: string) => `ترک ${text}`,
      cancelOption: 'لغو',
      confirmOption: (text: string) => `ترک ${text}`,
    },
    openLink: {
      title: 'آیا این لینک باز شود؟',
    },
    pushNotification: {
      description:
        'برای مطلع شدن از پیام‌هایی که براتون ارسال میشه اعلان رو فعال کنید.',
      title: 'فعال سازی اعلان',
    },
    discardVoiceMessage: {
      title: 'حذف پیام صوتی',
      description: 'آیا میخواهید پیام صوتی خود را حذف کنید؟',
    },
    discardRecordingVoice: {
      title: 'حذف پیام صوتی',
      description:
        'آیا از متوقف کردن ضبط صدا و حذف پیام صوتی خود اطمینان دارید؟',
    },
    logout: {
      description: 'آیا از پایان دادن به این نشست اطمینان دارید؟',
      title: 'پایان دادن به نشست',
      cancelOption: 'لغو',
      confirmOption: 'پایان دادن',
    },
    terminateSessions: {
      description: 'آیا از پایان دادن به باقی نشست‌ها اطمینان دارید؟',
      title: 'پایان دادن به نشست‌ها',
      cancelOption: 'لغو',
      confirmOption: 'پایان دادن',
    },
    deleteAccount: {
      description:
        'با حذف حساب کاربری تمامی گفتگو‌ها و مخاطبین شما برای همیشه حذف خواهد شد و غیرقابل بازیابی خواهد بود. آیا از این کار اطمینان دارید؟',
      title: 'حذف حساب کاربری',
      confirmOption: 'ادامه فرایند حذف حساب',
    },
    deleteHall: {
      description: (text: string) => `آیا از حذف و ترک ${text} اطمینان دارید؟`,
      checkboxOption: (text: string) => `حذف ${text} برای تمامی اعضا`,
      title: (text: string) => `حذف ${text}`,
      cancelOption: 'لغو',
      confirmOption: (text: string) => `حذف ${text}`,
    },
    clearDb: {
      description: 'آیا از پاک کردن حافظه موقت مطمئن هستید؟',
      title: 'پاک کردن حافظه موقت',
    },
    invite: {
      title: 'تایید دعوت',
      description: (phone: string) =>
        boldSome(
          'آیا از دعوت فردی با شماره موبایل',
          toLocale(phone),
          'مطمئن هستید؟',
        ),
      descriptions: (count: number) =>
        boldSome(
          'آیا از دعوت',
          toLocale(count),
          'نفر به این پلتفرم مطمئن هستید؟',
        ),
    },
    deleteContent: {
      description: 'آیا از حذف محتوای انتخاب شده اطمینان دارید ؟',
    },
    deleteContentFromInline: {
      checkboxOption: 'حذف محتوای انتخاب شده از ویترین دوره',
    },
    pinMessage: {
      title: 'سنجاق کردن پیام',
      description: 'آیا می‌خواهید این پیام را به بالای گفتگو سنجاق کنید؟',
      pinForUser: (name: string) => boldSome('برای ', name, ' نیز سنجاق شود'),
      sendNotif: (isGroup: boolean) =>
        `برای اعضا ${isGroup ? 'گروه' : 'کانال'} اعلان ارسال شود`,
    },
    replacePinMessage: {
      title:
        'آیا مطمئن هستید که می‌خواهید پیام جدیدی را به جای پیام قبلی سنجاق کنید؟',
    },
    unPinMessage: {
      title: 'برداشتن سنجاق',
      description: 'آیا از برداشتن سنجاق این پیام برای همه اطمینان دارید؟',
    },
    promoteToOwner: {
      title: 'انتقال مالکیت',
      description: (name: string) =>
        `آیا از انتقال مالکیت این کانال به ${name} اطمینان دارید؟`,
    },
    endOngoingCall: {
      callTypes: {
        call: 'تماس با',
        group_call: 'جلسه با',
        live: 'پخش زنده',
        tribune: 'تریبون',
        classroom: 'کلاس',
      },
      title: 'گفتگوی صوتی دیگری در جریان است',
      description: (ongoingCallDesc: string, newCallDesc: string) =>
        `آیا ${ongoingCallDesc} پایان یابد و ${newCallDesc} شروع شود؟`,
      confirmOption: 'بله',
    },
    disableRecentUsers: {
      title: 'غیر فعال کردن پیشنهاد‌ها',
      description:
        'این کار، اطلاعات مربوط به افرادی که مکررا برای آن‌ها پیام ارسال می‌کنید را در قسمت جستجو گفتگو حذف خواهد کرد.',
    },
  },
  selectMenu: {
    loading: 'در حال دریافت اطلاعات',
    nothingFound: 'موردی یافت نشد',

    county: {
      selectProvince: 'انتخاب استان',
      selectCounty: 'انتخاب شهر',
    },
    gender: {
      selectGender: 'انتخاب جنسیت',
    },
  },
  message: {
    VOICE: 'پیام صوتی',
    VIDEO: 'ویدیو',
    WAPP: 'وپ',
    FILE: 'فایل',
    IMAGE: 'عکس',
    AUDIO: 'فایل صوتی',
    CONTACT: 'مخاطب',
    tool: 'ابزار',
    forwardedFrom: 'ارسال شده از',
    edited: 'ویرایش شده',
    unreadMessages: 'پیام‌های خوانده نشده',
    deleted: 'پیام حذف شده',
    onboarding: {
      group: {
        title: (groupName: string) => `به گروه «${groupName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به گروه',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${prev} ${or} ${current}`
            return `${prev}${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      channel: {
        title: (channelName: string) => `به کانال «${channelName}» خوش آمدید!`,
        actions: {
          addMember: 'افزودن عضو',
          addDescription: 'اضافه کردن توضیحات به کانال',
          shareInviteLink: 'اشتراک گذاری لینک دعوت با مخاطبینتان',
        },
        actionButtons: {
          addMember: 'افزودن اعضا',
          addDescription: 'اضافه کردن توضیحات',
          shareInviteLink: 'اشتراک گذاری لینک دعوت',
        },
        description: (actions: string[]) => {
          const actionsStr = actions.reduce((prev, current, i, arr) => {
            const or = 'یا'
            const comma = '،'
            if (!prev) return current
            if (i === arr.length - 1) return `${prev} ${or} ${current}`
            return `${prev}${comma} ${current}`
          }, '')

          return `با ${actionsStr} شروع کنید!`
        },
      },
      pv: {
        title: 'هنوز پیامی در اینجا نیست...',
        description: 'پیامی ارسال کنید یا روی استیکر خوش آمدگویی بزنید',
      },
    },
  },
  chat: {
    issue: 'رفع اشکال',
    selectARoomToStart: 'برای شروع یکی از گفتگوها را انتخاب کنید',
    dropHereToSend: 'فایل خود را در این قسمت رها کنید',
    vitrine: 'ویترین',
    profileCompletion: 'اطلاعات ثبت نامی', // #moghavemat
    courseVitrine: 'فهرست دوره',
    event: {
      meetingStarted: (userId: string) => [
        getUserToken(userId),
        getTextToken('جلسه را آغاز کرد'),
      ],
      liveStarted: () => [getTextToken('پخش زنده شروع شد')],
      classStarted: () => [getTextToken('کلاس آنلاین شروع شد')],
      tribuneStarted: () => [getTextToken('تریبون شروع شد')],
      joinedGroupViaLink: (userId: string) => [
        getUserToken(userId),
        getTextToken('از طریق لینک به گروه پیوست'),
      ],
      joinedGroup: (userId: string) => [
        getUserToken(userId),
        getTextToken('به گروه پیوست'),
      ],
      leaveGroup: (userId: string) => [
        getUserToken(userId),
        getTextToken('گروه را ترک کرد'),
      ],
      signUpContact: (userId: string) => [
        getUserToken(userId),
        getTextToken(`به ${APP_NAME} پیوست`),
      ],
      addToGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(affectedUserId),
        getTextToken('توسط'),
        getUserToken(doerUserId),
        getTextToken(` به ${isGroup ? 'گروه' : 'کانال'} اضافه شد`),
      ],
      removeFromGroup: (
        doerUserId: string,
        affectedUserId: string,
        isGroup: boolean,
      ) => [
        getUserToken(affectedUserId),
        getTextToken('توسط'),
        getUserToken(doerUserId),
        getTextToken(` از ${isGroup ? 'گروه' : 'کانال'} حذف شد`),
      ],
      pinnedMessage: (userId: string, messageIid: number) => [
        getUserToken(userId),
        getTextToken(' «'),
        getMessageToken(messageIid),
        getTextToken(userId ? '» را سنجاق کرد' : '» سنجاق شد'),
      ],
      youJoinedChannel: 'شما به این کانال پیوستید',
    },

    sendVoiceDialog: {
      title: 'پیام صوتی',
    },

    // TODO: CHECK THIS FORM OF LOCALIZATION
    meetingStarted: 'جلسه را آغاز کرد',
    meetingEnded: 'جلسه به پایان رسید',
    liveStarted: 'پخش زنده شروع شد',
    classStarted: 'کلاس آنلاین شروع شد',
    liveEnded: 'پخش زنده به پایان رسید',
    classEnded: 'کلاس آنلاین به پایان رسید',
    tribuneStarted: 'تریبون شروع شد',
    tribuneEnded: 'تریبون به پایان رسید',
    joinedGroupViaLink: (name: string) => `${name} از طریق لینک به گروه پیوست`,
    signUpContact: `به ${APP_NAME} پیوست`,
    joinGroup: 'به گروه پیوست',
    leaveGroup: 'گروه را ترک کرد',
    addToGroup: (
      isGroup: boolean,
      doerUserName: string,
      affectedUserName: string,
    ) =>
      `${affectedUserName} توسط ${doerUserName} به ${
        isGroup ? 'گروه' : 'کانال'
      } اضافه شد`,
    removeFromGroup: (
      isGroup: boolean,
      doerUsername: string,
      affectedUsername: string,
    ) =>
      `${affectedUsername} توسط ${doerUsername} از ${
        isGroup ? 'گروه' : 'کانال'
      } حذف شد`,
    pinnedMessage: (doerUserName: string, message: string) =>
      `${doerUserName || ''} «${message}» ${
        doerUserName ? 'را سنجاق کرد' : 'سنجاق شد'
      }`,
    createHall: 'راه اندازی شد',
    removeHallImage: (isGroup: boolean) =>
      `عکس ${isGroup ? 'گروه' : 'کانال'} پاک شد`,
    changeHallImage: (isGroup: boolean) =>
      `عکس ${isGroup ? 'گروه' : 'کانال'} تغییر کرد`,
    changeHallName: (isGroup: boolean, hallNewName: string) =>
      `نام ${isGroup ? 'گروه' : 'کانال'} به «${hallNewName}» تغییر کرد`,
    typing: ' در حال نوشتن...',
    recordingVoice: 'در حال ضبط صدا...',
    uploadingVoice: 'در حال بارگذاری صدا...',
    uploadingVideo: 'در حال بارگذاری ویدیو...',
    uploadingFile: 'در حال بارگذاری فایل...',
    uploadingPhoto: 'در حال بارگذاری عکس...',
    uploadingAudio: 'در حال بارگذاری فایل صوتی...',
    tooManyOtherPeople: 'و چند نفر دیگر...',
    editMessage: 'ویرایش پیام',
    sendField: 'پیام بنویسید...',
    sendFieldCaption: 'نوشتن توضیحات...',
    sendImage: 'ارسال عکس',
    sendVideo: 'ارسال ویدیو',
    editImage: 'ویرایش عکس',
    editVideo: 'ویرایش ویدیو',
    recording: 'در حال ضبط',
    processing: 'در حال پردازش',
    replaceFile: 'جایگزینی فایل',
    replacement: 'جایگزینی',
    mute: 'بی‌صدا کردن',
    unMute: 'صدادار کردن',
    pinned: 'پیام سنجاق شده',
    aMessage: 'یک پیام',
    forward: 'هدایت',
    compressing: 'در حال فشرده‌سازی',
  },
  sendField: {
    brightness: 'آشکارسازی',
    contrast: 'کنتراست',
    saturation: 'شدت رنگ',
    hue: 'طیف رنگ',
    refresh: 'بازنشانی',
    upperQuality: 'کیفیت بالاتر',
    lessVolume: 'حجم کمتر',
  },
  feedbackDetailsDialog: {
    title: 'ثبت بازخورد',
    inputLabel: 'به چه مشکلی برخورد کردید؟',
    inputPlaceholder: 'توضیحات خودتان را وارد کنید',
  },
  requestToJoinHallDialog: {
    confirmText: 'ارسال درخواست عضویت',
    description: type =>
      `این ${
        type === 'CHANNEL' ? 'کانال' : 'گروه'
      } فقط پس از تایید توسط ادمین مشترک جدید می‌پذیرد`,
    subtitle: type => `${type === 'CHANNEL' ? 'کانال' : 'گروه'} خصوصی`,
  },
  callRoomIsFullDialog: {
    title: callName => `ظرفیت ${callName} تکمیل است`,
    description: callName =>
      `متأسفانه ظرفیت این ${callName} به حد نصاب رسیده و در حال حاضر امکان ورود وجود ندارد.`,
    submitText: 'متوجه شدم',
  },
  call: {
    connecting: 'در حال برقراری ارتباط...',
    incomingCall: 'تماس جریان...',
    ongoingCalls: {
      call: 'تماس در جریان',
      meeting: 'جلسه در جریان',
      live: 'پخش زنده در جریان',
      tribune: 'تریبون در جریان',
      classroom: 'کلاس آنلاین در جریان',
    },
    voiceCall: 'گفتگوی صوتی',

    group_call: 'جلسه',
    live: 'پخش زنده',
    tribune: 'تریبون',
    call: 'تماس',
    classroom: 'کلاس آنلاین',

    class: 'کلاس',

    watch: 'مشاهده',
    enter: 'ورود',
    join: 'پیوستن',
    leave: 'ترک',
    notification: 'اطلاع رسانی',
    startNow: 'شروع همین الان',

    startsAtDate: 'برگزاری در ',
    startsFrom: 'تا شروع',
    inProgress: 'در حال برگزاری',

    cancel: 'انصراف',
    accept: 'پذیرفتن',
    reject: 'رد کردن',
    retry: 'تلاش مجدد',
    callAgain: 'تماس مجدد',

    busy: 'خط مشغول است',
    ended: 'مکالمه تمام شد',
    rejected: 'رد تماس توسط مخاطب',
    'timed-out': 'مخاطب در دسترس نیست',
    canceled: 'لفو تماس توسط مخاطب',

    scheduledCallNotificationMessage: (
      type,
      startsAt,
      roomType,
      name,
      inviteLink,
    ) => {
      const firstRow = name
        ? `🔶 ${type} با عنوان ${name} در ${startsAt} برگزار خواهد شد.`
        : `🔶 ${type} در ${startsAt} برگزار خواهد شد.`
      return !inviteLink
        ? firstRow
        : `${firstRow} از لینک زیر به ${roomType} برگزاری آن بپیوندید:
${inviteLink}`
    },
    scheduledCallEventMessage: (
      callType: string,
      date: string,
      userName?: string,
    ) =>
      typeof userName === 'string'
        ? `${userName}${callType} را برای تاریخ ${date}، زمان بندی کرد`
        : `${callType} برای تاریخ ${date}، زمان بندی شد`,

    callFeedbackDialog: {
      title: (callTypeString: string, callType: string) =>
        `به کیفیت ${
          callType === 'tribune' ? 'صدا' : 'صدا و تصویر'
        } در این ${callTypeString} چه نمره‌ای می‌دهید؟`,
      qualityDescriptors: {
        veryBad: 'خیلی بد',
        bad: 'بد',
        normal: 'معمولی',
        good: 'خوب',
        veryGood: 'خیلی خوب',
      },
      problems: {
        title: 'مشکل کجا بود؟',
        noImage: 'تصویر را نداشتم',
        disconnectingAndConnectingTheImage: 'قطع و وصلی تصویر',
        noAudio: 'صدا را نداشتم',
        disconnectingAndConnectingTheAudio: 'قطع و وصلی صدا',
      },
      inputPlaceholder: 'مشکل خودتان را در صورت لزوم توضیح دهید',
      confirm: 'تایید',
    },

    status: {
      common: {
        busy: 'تماس ناموفق',
        rejected: 'تماس رد شد',
        canceled: 'تماس لغو شده',
      },
      opponent: {
        successful: 'تماس دریافتی',
        'timed-out': 'عدم پاسخگویی',
      },
      me: {
        successful: 'تماس موفق',
        'timed-out': 'تماس از دست رفته',
      },
    },
  },
  accounts: {
    deletedAccount: 'حساب کاربری حذف شده',
    deletedAccountAvatarText: 'ح‌ح',
    recentUserDeletedAccount: 'کاربر حذف شده',
  },
  contextMenu: {
    limitedByAdmin: (isGroup: boolean) =>
      `قابلیت کپی و ارسال به دیگران در ${
        isGroup ? 'گروه' : 'کانال'
      } توسط ادمین بسته شده است`,
    reply: 'پاسخ',
    forward: 'ارسال به دیگران',
    copyLink: 'کپی لینک',
    saveToDownloads: 'ذخیره در دانلودها',
    showSharedMedia: 'نمایش تمامی رسانه‌ها',
    haveSeen: (count: number) =>
      count > 1
        ? `${toLocale(count)} نفر دیده‌اند `
        : `${toLocale(1)} نفر دیده‌است `,

    openInWappDevEnv: 'توسعه وپ',
  },
  forceUpdateTwa: {
    title: `بروزرسانی جدید ${APP_NAME}`,
    description:
      'نسخه فعلی دیگر پشتیبانی نمی‌گردد، لطفا نسخه جدید را دریافت و نصب کنید.',
    button: 'دریافت نسخه جدید',
  },
  validation: {
    invitationLink: {
      leastChars: 'لینک دعوت باید حداقل ۵ کاراکتر باشد.',
      notSupportedChars: 'فقط حروف و اعداد انگلیسی و علامت _ مجاز است.',
      notStartWithLetter: 'لینک دعوت باید با حرف شروع شود.',
      exists: 'لینک دعوت وارد شده تکراری است.',
      isAvailable: 'این لینک دعوت معتبر است.',
    },
    username: {
      leastChars: 'نام کاربری باید حداقل ۵ کاراکتر باشد.',
      notSupportedChars: 'فقط حروف و اعداد انگلیسی و علامت _ مجاز است.',
      notStartWithLetter: 'نام کاربری باید با حرف شروع شود.',
      exists: 'نام کاربری وارد شده تکراری است.',
      isAvailable: 'این نام کاربری معتبر است.',
    },
  },
  snackbar: {
    failedToLoadUserWorkspaces: 'دریافت فضای اختصاصی با مشکل مواجه شد',
    hallsMovedToWorkspace: 'گفت‌وگوها با موفقیت به فضای اختصاصی منتقل شدند',
    hallsRemovedFromWorkspace: 'گفت‌وگوها با موفقیت از فضای اختصاصی حذف شدند',
    workspaceUpdated: 'فضای اختصاصی با موفقیت به روز شد',
    workspaceDeleted: 'فضای اختصاصی با موفقیت حذف شد',
    workspaceCreated: 'فضای اختصاصی با موفقیت ایجاد شد',
    trialIsActivatedOnce: 'نسخه آزمایشی پیش از این برای شما فعال شده است.',
    trialCantBeActivatedBecauseOfActivatedPlans:
      'با توجه به خرید بسته های وبلایت امکان فعال سازی نسخه آزمایشی وجود ندارد.',
    callRoomIsFull: (callType: string) => `ظرفیت ${callType} تکمیل شده است`,
    trialStartedSuccessfully: 'دموی نسخه ویژه برای شما فعال شد.',
    failedToStartTrial:
      'فعال‌سازی نسخه آزمایشی با مشکل مواجه شد. لطفا مجددا تلاش کنید',
    requestForPremiumPlanSentSuccessfully:
      'درخواست شما ثبت شده است. \n' +
      'بزودی کارشناسان ما با شما ارتباط میگیرند.',
    yourTrialHasExpired: 'مدت استفاده رایگان شما  تمام شده است',
    invite: {
      error: {
        FORBIDDEN: 'شما اجازه‌ی دعوت ندارید',
        EXCEEDS_CAPACITY: 'تعداد شماره‌ها بیشتر از ظرفیت دعوت شماست',
      },
      successfully: (invited: string, registered: string) =>
        `${invited ? `${invited} نفر با موفقیت دعوت شدند.` : ''}  ${
          registered
            ? `${registered} نفر از افرادی که دعوت کردید پیش از این ثبت نام کرده بودند.`
            : ''
        }`,
      noOneInvited: 'هیچ دعوتی با موفقیت انجام نشد',
    },
    couldntJoinClass:
      'در پیوستن به کلاس مشکلی پیش آمده است. لطفا دوباره تلاش کنید.',
    switchSyncContactActivation: (activated: boolean) =>
      `مخاطبین این دستگاه به این حساب کاربری اضافه ${
        activated ? 'خواهد' : 'نخواهد'
      } شد.`,
    invalidStoryFileType: 'نوع فایل انتخابی شما برای ماجرا پشتیبانی نمی‌شود',
    inviteLinkSentSuccessfully: 'لینک دعوت برای مخاطبین ارسال شد',
    joinRequestSentSuccessfully: 'درخواست عضویت با موفقیت ارسال شد',
    youHaveAlreadyRequestedToJoin: 'شما قبلاً درخواست عضویت داده‌اید',
    joinRequestAccepted: userName => `${userName} با موفقیت به کانال پیوست`,
    joinRequestRejected: userName => `درخواست ${userName} رد شد`,
    failedToAcceptJoinRequest: userName =>
      `تایید درخواست عضویت ${userName} با مشکل مواجه شد`,
    failedToRejectJoinRequest: userName =>
      `رد درخواست عضویت ${userName} با مشکل مواجه شد`,
    incomingCallAcceptedFromAnotherDevice:
      'تماس در یکی دیگر از دستگاه‌های شما پاسخ داده شد.',
    usernameIsInvalid: 'نام کاربری مورد نظر پیدا نشد',
    maxCharacterInTextMessageReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک پیام متنی رسیده‌اید.',
    maxCharacterInCaptionReached:
      'شما به بیشترین حد استفاه از کاراکتر در یک زیرمتن رسیده‌اید.',
    syncedContactsClearedSuccessfully: 'مخاطبین شما حذف شد',
    infoSuccessfullyUpdated: 'ویرایش اطلاعات با موفقیت انجام شد',
    signupEndedSuccessfully: 'ثبت نام با موفقیت انجام شد',
    reloadingContactsInProgress: 'در حال بروزرسانی مخاطبین',
    ContactsReloadedSuccessfully: 'بروزرسانی مخاطبین با موفقیت انجام شد',
    maximumNumberOfHallAdminsExceeded: limit =>
      `حداکثر ${limit} نفر میتوانند مدیر باشند.`,
    noForwardPermission: {
      text: 'شما اجازه ارسال به این چت را ندارید',
    },
    fileMessageSizeLimitExceeded: maximumSize =>
      `حجم فایل ارسالی نمیتواند بیشتر از ${maximumSize} مگابایت باشد!`,
    call: {
      userBanned: (callType: string) =>
        `دسترسی شما به این ${callType} ممنوع شده است`,
      requestFailed: 'درخواست شما با مشکل مواجه شد. لطفا دوباره تلاش کنید.',

      joinFailed: (callType: string) =>
        `در پیوستن به ${callType} مشکلی پیش آمده است. لطفا دوباره تلاش کنید.`,
      roomIsFull: `متاسفانه ظرفیت تماس به اتمام رسیده است`,

      startFailed: (callType: string) =>
        `شروع ${callType} با مشکل مواجه شد. لطفا دوباره تلاش کنید.`,

      noInternetConnection: 'لطفا اتصال اینترنت خود را بررسی کنید.',

      edited: type => `${type} با موفقیت ویرایش شد`,
      deleted: type => `زمان‌بندی ${type} حذف شد`,
    },
    noPermissionToSend: {
      text: 'شما اجازه ارسال پیام در این گفت‌و‌گو را ندارید',
    },
    identifierNotExist: {
      text: 'شناسه مورد نظر وجود ندارد',
    },
    connectionProblem: {
      text: 'مشکلی در اتصال به سرور وجود دارد',
    },
    genImageFailed: {
      text: 'تولید تصویر موردنظر با مشکل مواجه شده است',
    },
    genTextFailed: {
      text: 'تولید متن موردنظر با مشکل مواجه شده است',
    },
    operationFailed: {
      text: 'مشکلی در انجام عملیات رخ داده است',
    },
    newUpdateIsAvailable: {
      text: 'نسخه‌ی جدید دریافت شده است!',
      actionText: 'راه اندازی',
    },
    installPWAPrompt: {
      text: 'نصب اپلیکیشن',
      actionText: 'دریافت',
    },
    thereIsAProblemInConnection: {
      text: 'مشکلی در اتصال وجود دارد',
    },
    inviteLinkExpired: {
      text: 'لینک دعوت باطل شد',
    },
    invalidLink: {
      text: 'لینک معتبر نیست',
    },
    nMemberRemovedFromHall: {
      text: (count: string, type: string) => `${count} عضو از ${type} حذف شد`,
    },
    canNotAccessViaForwardedMessage: {
      text: 'حساب کاربری توسط کاربر پنهان شده است',
    },
    historyWasCleared: {
      text: 'تاریخچه‌ی گفت‌و‌گو پاک شد',
    },
    chatsRemoved: {
      text: 'گفت‌وگوها حذف شدند',
    },
    chatRemoved: {
      text: 'گفت‌وگو حذف شد',
    },
    textSavedInMemory: {
      text: 'متن در حافظه ذخیره شد',
    },
    linkSavedInMemory: {
      text: 'لینک در حافظه ذخیره شد',
    },
    hashtagSavedInMemory: {
      text: 'هشتگ در حافظه ذخیره شد',
    },
    phoneNumberSavedInMemory: {
      text: 'شماره‌ی همراه در حافظه ذخیره شد',
    },
    reportSent: {
      text: 'گزارش با موفقیت ثبت شد',
    },
    bioSavedInMemory: {
      text: 'معرفی کوتاه در حافظه ذخیره شد',
    },
    usernameSavedInMemory: {
      text: 'نام کاربری در حافظه ذخیره شد',
    },
    userBanned: {
      text: 'کاربر مسدود شد',
    },
    userUnbanned: {
      text: 'کاربر رفع مسدودیت شد',
    },
    uploadingImage: {
      text: 'تصویر در حال بارگذاری است',
    },
    userRemovedFromYourContact: {
      text: {
        postfix: 'از مخاطبین شما حذف شد',
      },
    },
    userPromotedToAdmin: {
      text: {
        postfix: 'به مدیر ارتقا یافت',
      },
    },
    userRemovedFromRoom: {
      text: {
        postfix: {
          prefix: 'از',
          postfix: 'حذف شد',
        },
      },
    },
    nMessageForwardedToChat: {
      text: (multipleMessage: boolean, count: string) =>
        `پیام‌${multipleMessage ? 'ها' : ''} به ${count} گفت‌و‌گو هدایت ${
          multipleMessage ? 'شدند' : 'شد'
        }`,
    },
    selectionLimit: {
      text: (count: number) =>
        `انتخاب بیشتر از ${toLocale(count)} نفر مجاز نیست`,
    },
    sharedSuccessfully: 'پیام شما با موفقیت ارسال شد',
    pinnedSuccessfully: 'پیام سنجاق شد',
    unPinnedSuccessfully: 'سنجاق پیام برداشته شد',
    messageNotExist: 'پیام وجود ندارد',
    pinRoomLimit: {
      text: `متاسفانه نمیتوانید بیش از ${toLocale(
        LIMITS.pinnedRoomsCount,
        false,
      )} گفت‌وگو را سنجاق کنید`,
    },
  },
  roomPins: {
    pinned: (count: number) => `${toLocale(count)} پیام سنجاق شده`,
    removeAllPins: 'برداشتن سنجاق تمامی پیام‌ها',
  },
  activeSessions: {
    currentDevice: 'دستگاه فعلی',
    deactivateOtherDevices: 'غیرفعال کردن دستگاه‌های دیگر',
    otherActiveDevices: 'سایر دستگاه‌های فعال',
    unknownInformation: 'اطلاعات نامشخص',
    terminateSession: 'پایان دادن به نشست',
  },
  iosCallProblemsModal: {
    description:
      'کاربر عزیز، با توجه به سیستم عامل گوشی شما (iOS) ممکن است که این سامانه با مشکلاتی مواجه شود. آیا از ورود به این سامانه اطمینان دارید؟',
    confirmText: 'ورود به نسخه آزمایشی',
  },
  chooseChannelCallModal: {
    title: 'نوع ابزار ارتباطی را انتخاب کنید:',
    groupCallDescription: 'برگزاری جلسات گروهی',
    liveDescription: 'برگزاری رویدادهای تصویری',
    tribuneDescription: 'برگزاری رویدادهای صوتی',
    classroomDescription: 'برگزاری کلاس آنلاین',
    start: 'شروع',
    callLimit: (limit: number) => `محدودیت: ${toLocale(limit)} نفر`,
  },
  chooseHallCallTimeModal: {
    creatingCall: {
      tribune: 'برگزاری تریبون',
      meeting: 'برگزاری جلسه',
      live: 'برگزاری پخش زنده',
      classroom: 'برگزاری کلاس آنلاین',
    },
    editingCall: {
      tribune: 'ویرایش زمانبندی تریبون',
      meeting: 'ویرایش زمانبندی جلسه',
      live: 'ویرایش زمانبندی پخش زنده',
      classroom: 'ویرایش زمانبندی کلاس آنلاین',
    },
    schedulingCall: {
      tribune: 'زمانبندی تریبون',
      meeting: 'زمانبندی جلسه',
      live: 'زمانبندی پخش زنده',
      classroom: 'زمانبندی کلاس آنلاین',
    },
    title: 'عنوان',
    titleError: {
      tribune: 'عنوان تریبون نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      group_call: 'عنوان جلسه نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      live: 'عنوان پخش زنده نمی‌تواند کمتر از ۳ کاراکتر باشد.',
      classroom: 'عنوان کلاس آنلاین نمی‌تواند کمتر از ۳ کاراکتر باشد.',
    },
    titlePlaceholder: 'عنوان را وارد کنید',
    startTime: 'زمان شروع',
    selectStartTime: 'انتخاب زمان شروع',
    sendNotificationInChannel: 'ارسال پیام اطلاع‌رسانی در کانال',
    sendNotificationInGroup: 'ارسال پیام اطلاع‌رسانی در گروه',
    delete: 'حذف',
    save: 'ذخیره',
    start: 'شروع',
    startNow: 'شروع همین الان',
    scheduleForLater: 'زمان بندی برای بعد',
    startAtChosenDate: 'شروع در زمان انتخاب شده',
    optional: 'اختیاری',
  },
  toolBoxModal: {
    contact: 'مخاطب',
    header: 'ابزارها',
    actions: {
      image: 'عکس',
      video: 'ویدیو',
      file: 'فایل',
      location: 'موقعیت',
      contact: 'مخاطب',
    },
  },
  bookmarkModal: {
    management: 'مدیریت',
    bookmark: 'نشان کردن',
    bookmarked: 'نشان شده',
    report: 'گزارش',
    remove: 'حذف محتوا',
    edit: 'ویرایش محتوا',
  },
  shareWappModal: {
    shareInSahab: `ارسال به دیگری در ${APP_NAME}`,
    shareOutOfSahab: 'ارسال در سایر شبکه‌های اجتماعی',
    copy: 'رونوشت لینک مستقیم',
  },
  seenListModal: {
    today: 'امروز در ',
    yesterday: 'دیروز در ',
    customDate: (date: string, time: string) => `
      ${date} در ${time}  
    `,
  },
  hallAdvancedSettings: {
    protectContent: {
      title: 'محدود کردن ارسال به دیگران',
      description: 'جلوگیری از ارسال محتواهای کانال به چت‌های دیگر',
    },
  },
  createHall: {
    createChannel: 'ایجاد کانال',
    createGroup: 'ایجاد گروه',
    createInWorkspace:
      'این کانال فقط از داخل فضای اختصاصی شما در دسترس خواهد بود و در گفتگو‌های عمومی نمایش داده نمی‌شود. پس از ایجاد کانال قابلیت جا‌به‌جایی وجود دارد.',
    default: {
      title: 'عادی',
      description:
        'به منظور اشتراک گذاری محتوا ساخته می‌شود \n' +
        '(مشابه پیام رسان‌های دیگر)',
    },
    educational: {
      title: 'آموزشی',
      description: 'دارای قابلیت‌های ویژه آموزشی از جمله کلاس آنلاین',
    },
    mookeb: {
      title: 'موکب',
      description: 'دارای قابلیت‌های ویژه از جمله ابزار حرکت',
    },
    advancedOptions: 'قابلیت‌های پیشرفته',
  },
  bookmarkSelectionListModal: {
    noList: 'فهرستی وجود ندارد',
    shouldMakeAList: 'برای اضافه کردن محتوا یک فهرست ایجاد کنید',
    contentCount: (count: number) => `${toLocale(count)} محتوا`,
    noContent: 'بدون محتوا',
    createCollection: 'ایجاد فهرست',
    editCollection: 'ویرایش فهرست',
    add: 'افزودن',
  },
  bookmarkMakeListModal: {
    title: 'عنوان فهرست',
    placeholder: 'عنوان فهرست را وارد کنید',
    shouldNotBeEmpty: 'عنوان فهرست را وارد کنید',
  },
  staticWappsModal: {
    onboarding: {
      description: 'برای آشنایی با این بخش روی اطلاعات بیشتر بزنید...',
      buttonText: 'اطلاعات بیشتر',
    },
  },
  permissionModal: {
    mic: 'میکروفون',
    camera: 'دوربین',
    notifications: 'اعلان‌ها',
    contacts: 'مخاطبان',
    promptTitle: (name: string) => `دسترسی برای ${name}`,
    deniedTitle: (name: string) => `عدم دسترسی به ${name}`,
    promptDescription: (name: string) =>
      `به منظور فعال‌سازی ${name}، روی ادامه زده و بعد گزینه allow رو انتخاب کنید`,
    deniedDescription: (name: string) =>
      `شما مجوز دسترسی به ${name} را به ${APP_NAME} نداده‌اید. برای راهنمایی بیشتر به منظور فعال کردن ${name}، روی اطلاعات بیشتر بزنید.`,
    infoOption: 'اطلاعات بیشتر',
    updateTwaVersion: {
      title: 'انتشار نسخه جدید اندروید',
      description:
        'نسخه جدید اندروید منتشر شده است، همین الان آن را دریافت و نصب کنید!',
      confirmOption: 'دریافت و نصب',
      cancelOption: 'بعدا',
    },
    clockMismatch: {
      title: 'عدم تطابق ساعت',
      description:
        'کاربر عزیز، ساعت دستگاه شما مطابق با ساعات رسمی کشور نیست و نیازمند اصلاح است. برای دیدن نحوه اصلاح آن، وارد لینک زیر شوید.',
    },
    notification: {
      title: 'در جریان همه اتفاقات قرار بگیرید!',
      description:
        'برای دسترسی به تمامی امکانات این برنامه، در پنجره‌ باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'فعال کردن اعلان‌ها',
    },
    notYet: 'فعلا نه',
    contact: {
      title: 'دوستان و آشنایان خود را پیدا کنید!',
      description:
        'برای دسترسی به به لیست مخاطبین خود، در پنجره باز شده در ادامه، گزینه "Allow" را بزنید',
      activate: 'اجازه دسترسی به مخاطبین',
    },
  },
  wapps: {
    post: 'پست',
    poll: 'نظرسنجی',
    meeting: 'جلسه',
    event: 'رویداد',
    blog: 'بلاگ',
    multimedia: 'آثار',
    form: 'فرم',
    forum: 'هم‌اندیشی',
    rahkar: 'حرکت',
    unknown: 'ابزار',
    tribune: 'تریبون',
    map: 'موقعیت',
    nevise: 'نویسه',
    generalExam: 'آزمون',
    generativeAI: 'هوش مصنوعی',
    wappDevEnv: 'محیط توسعه وپ',
    porsesh: 'رفع اشکال',
  },
  chatListToolbox: {
    title: 'جعبه ابزار',
    otherWapps: 'سایر ابزارها',
    wappDescription: {
      neviseh:
        'ابزاری کارآمد برای تولید انواع محتوای چند‌رسانه‌ای مشابه قالب بلاگ‌ها، مقالات و سایت‌های خبری',
      generalExam: 'مناسب برای برگزاری آزمون‌های تستی',
      form: 'مناسب برای ایجاد انواع پرسش‌نامه',
      poll: 'مناسب برای برگزاری نظرسنجی‌های چند گزینه‌ای',
      wappDevEnv: 'محیطی برای توسعه وپ‌ها و تست قابلیت‌های ارائه‌شده به آن‌ها',
    },
  },

  emojiPicker: emojiPickerI18n,
  errorBoundary: {
    applicationCrashed: 'برنامه با مشکل مواجه شد!',
    tryAgainOrCallSupport:
      'متاسفانه صفحه‌ای که وارد آن شدید دچار خطا شده است، دوباره تلاش  کنید و در صورت تکرار مشکل به پشتیبانی اطلاع دهید',
    contactSupport: 'ارتباط با پشتیبانی',
  },
  warningPages: {
    browserNotSupported: {
      title: 'مرورگر نامناسب',
      useSafari: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر سافاری',
        text2: 'استفاده کنید',
      },
      useChrome: {
        text1:
          'مرورگری که از آن استفاده می‌کنید پشتیبانی نمی‌شود. برای جلوگیری از مشکلات احتمالی، از مرورگر کروم',
        text2: 'استفاده کنید',
      },
    },
    outdatedBrowser: {
      title: 'مرورگر قدیمی',
      description:
        'نسخه مرورگر شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی نمایید.',
      yourVersion: 'نسخه مرورگر شما',
      minVersion: 'نسخه قابل اجرا',
    },
    outdatedOs: {
      oldAndroid: 'اندروید قدیمی',
      oldIos: 'آی او اس قدیمی',
      updateAndroid:
        'نسخه اندروید شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
      updateIos:
        'نسخه آی او اس شما قدیمی است. برای جلوگیری از مشکلات احتمالی، آن را بروزرسانی یا از دستگاه دیگری استفاده نمایید.',
    },
  },
  invite: {
    inviteViaPhone: 'دعوت از طریق شماره موبایل',
    checkboxOption: 'امکان دعوت دیگران را داشته باشد',
    inviteFromContacts: 'دعوت از لیست مخاطبین',
    yourInviter: 'دعوت کننده شما به پلتفرم',
    invited: 'دعوت شدگان',
    accepted: 'پذیرندگان دعوت',
    invitedAt: (date: number) =>
      `در تاریخ ${dateTimeFormatter.format(date)} دعوت شد`,
    invitationStatus: 'ظرفیت دعوت شما: ',
    sms: `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    oneUserSms: (
      phone: string,
    ) => `سلام و عرض ادب، شما به پلتفرم ${APP_NAME} دعوت شده اید.
     ${phone}شماره تلفن دعوت شده: 
    ورود به پلتفرم: ${FRONT_HOST.replace(/(^\w+:|^)\/\//, '')}
    دانلود نسخه اندروید: ${TWA_DOWNLOAD_SRC.replace(/(^\w+:|^)\/\//, '')}`,
    increaseCapacity: 'افزایش ظرفیت',
  },
  forward: {
    text: 'پیام',
    wapp: 'اپلیکیشن',
    forwardSameMessages: (num: number, type: string) =>
      `هدایت ${toLocale(num)} ${type}`,
    forward: (num: number) => `هدایت ${toLocale(num)} پیام`,
    from: (name: string) => `از طرف ${name}`,
    fromTwo: (name1: string, name2: string) => `از طرف ${name1} و ${name2}`,
    fromSome: (name1: string, name2: string) =>
      `از طرف ${name1} و ${name2}و ...`,
    nMessages: (num: number) => `${toLocale(num)} پیام`,
    whatUDo: (num: number, src: string) =>
      `تمایل دارید با ${toLocale(num)} پیام از ${src} چه کنید؟`,
    discardForward: 'لغو هدایت',
  },
  shareContact: {
    choose: 'انتخاب مخاطب',
    share: 'اشتراک گذاری مخاطب',
    viewContact: 'مشاهده مخاطب',
  },
}
